import React from "react";
import ArrowIcon from "../../../assets/svg/icons/common/arrow";
import Pagination from "../../../components/Pagination/Pagination";
import useCommonStore from "../../../stores/common";
import styles from "../Application.module.scss";
import ActionBar from "./ActionBar/ActionBar";
import ApplicationRow from "./ApplicationRow";
import ApplicationCard from "./ApplicationCard";
import useApplicationStore from "../../../stores/application";
import Checkbox from "../../../components/Checkbox/Index";
import useUserStore from "../../../stores/user";
import SkeletonRow from "../../../components/skeleton-loader/table/row";
import rowsToFill from "../../../utils/rows-to-fill";
import useDomainStore from "../../../stores/domain";

function ApplicationListing({ fetchList }) {
  const { isKurvDomain } = useDomainStore();
  const showDetails = useCommonStore((state) => state.showDetails);
  const preappsLoading = useApplicationStore((state) => state.preappsLoading);
  const selectedApps = useApplicationStore((state) => state.selectedApps);
  const setSelectedApps = useApplicationStore((state) => state.setSelectedApps);
  const preapps = useApplicationStore((state) => state.preapps);
  const appFilterSearchQuery = useApplicationStore(
    (state) => state.appFilterSearchQuery,
  );
  const setAppFilterSearchQuery = useApplicationStore(
    (state) => state.setAppFilterSearchQuery,
  );
  const pageCount = useApplicationStore((state) => state.pageCount);
  const totalItems = useApplicationStore((state) => state.totalItems);
  const itemsPerPage = useApplicationStore((state) => state.itemsPerPage);
  const isPCAdmin = useUserStore((state) => state.isPCAdmin);
  const isAdmin = useUserStore((state) => state.isAdmin);
  const onSortClick = (field) => {
    setAppFilterSearchQuery({
      sortBy: field,
      sortValue: appFilterSearchQuery.sortValue == "DESC" ? "ASC" : "DESC",
    });
  };

  const onAllAppsSelected = (event) => {
    const allIds = preapps.map((preapp) => preapp.id);
    if (event.target.checked) {
      setSelectedApps(allIds);
    } else {
      setSelectedApps([]);
    }
  };

  const activeApp = useApplicationStore((state) => state.activeApp);
  const setActiveApp = useApplicationStore((state) => state.setActiveApp);
  const setShowDetails = useCommonStore((state) => state.setShowDetails);

  const handleCardClick = (app) => {
    setActiveApp(app);
    setShowDetails(true);
  };

  return (
    <>
      <div className={styles.desktop_table}>
        <table>
        <thead>
          <tr>
            <th>
              <Checkbox
                checked={
                  selectedApps.length > 0 &&
                  selectedApps.length == preapps.length
                }
                onChange={onAllAppsSelected}
              />
            </th>
            <th
              className={styles.sortable_th}
              onClick={() => onSortClick("field_dba")}
            >
              DBA
              {appFilterSearchQuery.sortBy == "field_dba" && (
                <button
                  className={`${styles.sorting_button} ${appFilterSearchQuery.sortValue == "DESC" ? "" : styles.asc}`}
                >
                  <ArrowIcon />
                </button>
              )}
            </th>
            <th
              className={styles.sortable_th}
              onClick={() => onSortClick("progression_id")}
            >
              STATUS
              {appFilterSearchQuery.sortBy == "progression_id" && (
                <button
                  className={`${styles.sorting_button} ${appFilterSearchQuery.sortValue == "DESC" ? "" : styles.asc}`}
                >
                  <ArrowIcon />
                </button>
              )}
            </th>
            {!showDetails && (
              <th
                className={styles.sortable_th}
                onClick={() => onSortClick("id")}
              >
                ID
                {appFilterSearchQuery.sortBy == "id" && (
                  <button
                    className={`${styles.sorting_button} ${appFilterSearchQuery.sortValue == "DESC" ? "" : styles.asc}`}
                  >
                    <ArrowIcon />
                  </button>
                )}
              </th>
            )}

            {isPCAdmin ? (
              <th>ORGANIZATION</th>
            ) : isAdmin ? (
              <th>SALES REP</th>
            ) : (
              ""
            )}

            {!showDetails && (
              <th
                className={styles.sortable_th}
                onClick={() => onSortClick("created_at")}
              >
                CREATED
                {appFilterSearchQuery.sortBy == "created_at" && (
                  <button
                    className={`${styles.sorting_button} ${appFilterSearchQuery.sortValue == "DESC" ? "" : styles.asc}`}
                  >
                    <ArrowIcon />
                  </button>
                )}
              </th>
            )}
            {/* TODO: Add alerts column will do later */}
            {/* <th>ALERTS</th> */}
            {!showDetails && <th></th>}
          </tr>
        </thead>
        <tbody>
          {preappsLoading &&
            Array.from({ length: rowsToFill(window.innerHeight) }).map(
              (_, index) => (
                <SkeletonRow
                  key={index}
                  columnLength={isPCAdmin || isAdmin ? 7 : 6}
                />
              ),
            )}

          {preapps.map((preapp) => (
            <ApplicationRow
              key={preapp.id}
              app={preapp}
              fetchList={fetchList}
            />
          ))}
        </tbody>
      </table>
      </div>

      <div className={styles.mobile_cards_container}>
        {preappsLoading &&
          Array.from({ length: rowsToFill(window.innerHeight) }).map(
            (_, index) => (
              <div key={index} className={styles.skeleton_card}>
                <SkeletonRow
                  columnLength={1}
                  height="1.14em"
                  paddingX="0"
                />
              </div>
            ),
          )}

        {preapps.map((preapp) => (
          <ApplicationCard
            key={preapp.id}
            app={preapp}
            onClick={() => handleCardClick(preapp)}
            isSelected={activeApp?.id === preapp.id}
          />
        ))}
      </div>

      {preapps?.length < 1 && (
        <h6 className={styles.no_data_found}>No data to display</h6>
      )}

      {preapps?.length > 0 && (
        <div className={styles.pagination_container}>
          <Pagination
            pageCount={pageCount}
            currentPage={appFilterSearchQuery.page - 1}
            onPageChange={({ selected }) => {
              setAppFilterSearchQuery({
                page: selected + 1,
              });
              setSelectedApps([]);
            }}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
          />
        </div>
      )}

      {selectedApps.length > 0 && (
        <ActionBar
          selectedApps={selectedApps}
          close={() => {
            setSelectedApps([]);
          }}
          fetchList={fetchList}
        />
      )}
    </>
  );
}

export default ApplicationListing;
